import React, { Fragment } from 'react';
import { useController, ApplicationView as view } from '@aha-app/mvc';
import FieldPreview from './FieldPreview';
import DraggableFieldPreview from '../dnd/DraggableFieldPreview';
import ItemList from 'javascripts/dnd/components/ItemList';
import styles from './styles.module.css';
import CardLayoutEditorController from '../controllers/CardLayoutEditorController';
import type FieldSet from '../models/FieldSet';
import type Field from '../models/Field';
import { type VisibleFieldSet } from '../controllers/types';

interface FieldSetPreviewProps {
  fieldSet: FieldSet | VisibleFieldSet;
  fields: Field[];
  customName?: String;
}

const FieldSetPreview: React.FC<FieldSetPreviewProps> = ({
  fieldSet,
  fields,
  customName,
}) => {
  const controller = useController(CardLayoutEditorController);

  return (
    <Fragment>
      <dt>{customName || fieldSet.title}</dt>
      <dd className={styles.fieldSet}>
        <ItemList
          items={fields}
          createDraggableItem={field =>
            new DraggableFieldPreview({
              controller,
              item: field,
            })
          }
          hideDragPreviews={false}
          listKey={`FieldSetPreview-${fieldSet.constructor.name}`}
          ItemComponent={FieldPreview}
        />
      </dd>
    </Fragment>
  );
};

export default view(FieldSetPreview);
